import { Box, TextField, Typography } from "@mui/material";
import { primary } from "../../../../theme/constants";

interface IProps {
  label: string;
  inputIcon: string;
  value: string;
  onChange: any;
}

const TextWithInput = ({ label, inputIcon, value, onChange }: IProps) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography>{label}</Typography>
      <Box display="flex" alignItems="center">
        <Typography marginRight={2} variant="h4" style={{ color: primary }}>
          {inputIcon}
        </Typography>
        <TextField
          onChange={onChange}
          value={value}
          type="number"
          fullWidth
          id="outlined-basic"
          variant="outlined"
          style={{ border: "1px solid #9171FF", borderRadius: "5px" }}
        />
      </Box>
    </Box>
  );
};

export default TextWithInput;
